import { connect } from 'react-redux';
import _ from 'lodash';
import Podcast from './Podcast';

const mapState = state => {
	return {
		user: state.user,
		categories: _.get(state, 'categories', {}),
		items: _.get(state, 'items.data', {}),
		settings: _.get(state, 'settings', {}),
	};
};

const mapDispatch = {};

export default connect(
	mapState,
	mapDispatch
)(Podcast);
